export const POST_MORCEAU_RETURN = 'POST_MORCEAU_RETURN';
export const POST_MORCEAU_SAGAS = 'POST_MORCEAU_SAGAS';

export const GET_MORCEAUX_RETURN = 'GET_MORCEAUX_RETURN';
export const GET_MORCEAUX_SAGAS = 'GET_MORCEAUX_SAGAS';

export const PUT_MORCEAU_RETURN = 'PUT_MORCEAU_RETURN';
export const PUT_MORCEAU_SAGAS = 'PUT_MORCEAU_SAGAS';

export const PUT_MORCEAUX_ORDRE_RETURN = 'PUT_MORCEAUX_ORDRE_RETURN';
export const PUT_MORCEAUX_ORDRE_SAGAS = 'PUT_MORCEAUX_ORDRE_SAGAS';

export const DEL_MORCEAU_RETURN = 'DEL_MORCEAU_RETURN';
export const DEL_MORCEAU_SAGAS = 'DEL_MORCEAU_SAGAS';

// POST MORCEAU
export const postMorceauSagas = (xAccess, data) => ({
	type: POST_MORCEAU_SAGAS,
	token: xAccess,
	data: data
});
export const postMorceauReturn = (result) => ({
	type: POST_MORCEAU_RETURN,
	payload: result
});

// GET MORCEAUX
export const getMorceauxSagas = (xAccess) => ({
	type: GET_MORCEAUX_SAGAS,
	token: xAccess
});
export const getMorceauxReturn = (result) => ({
	type: GET_MORCEAUX_RETURN,
	payload: result
});

// PUT MORCEAU
export const putMorceauSagas = (uuid, xAccess, data) => ({
	type: PUT_MORCEAU_SAGAS,
	token: xAccess,
	payload: uuid,
	data: data
});
export const putMorceauReturn = (result) => ({
	type: PUT_MORCEAU_RETURN,
	payload: result
});

// PUT MORCEAUX ORDRE
export const putMorceauxOrdreSagas = (xAccess, ordreList) => ({
	type: PUT_MORCEAUX_ORDRE_SAGAS,
	token: xAccess,
	data: ordreList
});
export const putMorceauxOrdreReturn = (result) => ({
	type: PUT_MORCEAUX_ORDRE_RETURN,
	payload: result
});

// DELETE MORCEAU
export const deleteMorceauSagas = (uuid, xAccess) => ({
	type: DEL_MORCEAU_SAGAS,
	token: xAccess,
	payload: uuid
});
export const deleteMorceauReturn = (result) => ({
	type: DEL_MORCEAU_RETURN,
	payload: result
});
